import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getSessionSubject,
  patchSessionSubject,
  type SubjectDrop,
} from "@/services/api/subject";

const subjectKey = (sessionId: string | null) => ["session-subject", sessionId];

export function useSessionSubject(sessionId: string | null) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: subjectKey(sessionId),
    queryFn: () => getSessionSubject(sessionId as string),
    enabled: Boolean(sessionId),
    refetchInterval: 30_000,
    staleTime: 10_000,
  });

  const mutation = useMutation({
    mutationFn: (drop: SubjectDrop) =>
      patchSessionSubject(sessionId as string, drop),
    onSuccess: (data) => {
      queryClient.setQueryData(subjectKey(sessionId), data);
    },
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    drop: mutation.mutate,
    isDropping: mutation.isPending,
  };
}
